<template>
  <div>
    <div class="container mains">
      <div v-html="zhifusrc">{{zhifusrc}}</div>
    </div>
  </div>
</template>
<script>
import { zhifubao, getorder } from "../api/order/order";
import public_header from "../components/header.vue";
import public_footer from "../components/footer.vue";
const formJson = {
  consignee: "",
  mobile: "",
  sheng: "",
  shi: "",
  qu: "",
  address: "",
  user_id: "",
  order_id: ""
};
export default {
  name: "alipayzhifu",
  data() {
    return {
      htmls: "",
      zhifusrc: ""
    };
  },
  components: {
    public_header,
    public_footer
  },
  methods: {
    getorderrecord() {
      getorder({
        order_id: this.$route.query.order_id,
        user_id: this.$route.query.user_id
      }).then(response => {
        if (response.data.code != "error") {
          let param = {
            order_id: this.$route.query.order_id,
            order_sn: response.data.data.order_number,
            order_amount: response.data.data.amount,
            // order_amount: 0.01,
            order_xuzu: this.$route.query.order_xuzu
          };
          zhifubao(param).then(response => {
            if (response.data) {
              if(response.data.code&&response.data.code=='409'){
                  this.$router.push("/myorder");
                  this.$message.error(response.data.msg||response.data.message)
                  return
                }
              let routerData = this.$router.push({
                path: "/zhifubaozf",
                query: { htmls: response.data.data }
              });
              this.htmls = response.data.data;
              //打开新页面
              window.open(routerData.href, "_ blank");
              const div = document.createElement("div");
              div.innerHTML = this.htmls;
              document.body.appendChild(div);
              document.forms[0].submit();
            } else {
              this.zhifusrc = "";
            }
          });
        }
      });
    }
  },
  created() {
    this.getorderrecord();
  }
};
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/pages/alipayzhifu.vue